import React, { useEffect } from "react";
import { Row, Col} from "react-bootstrap";
import swal from 'sweetalert';
import { validationRules, customFieldTypes } from "../../constants/staticVariables";

const CustomFields = ({ customFormData, setCustomFormData, setRule, validator }) => {
    const formStyles = {
        formContainer: {
            margin: "0 15px"
        },
        hideLabel: {
            visibility: "hidden"
        },
        checkboxStyle: {
            display: "flex",
            alignItems: "flex-start"
        },
        optionContainer: {
            display: "flex",
            alignItems: "baseline"
        },
        buttonStyle: {
            margin: "3px -25px 0px 10px"
        },
        checkboxMargin: {
            marginLeft: "5px"
        }
    }
    const fieldTypes = ["select","radio","checkbox"]
    const disableRequiredTypes = ["radio","checkbox"]
    const handleInputChange = (e) => {
        const name = e.target.name;
        const fieldId = e.target.name === "fieldName" ? e.target.value.toLowerCase() : e.target.value;
        const value = e.target.type === "checkbox" ? e.target.checked : fieldId;
        if (name === "validationRule") {
            setRule("")
        }
        setCustomFormData(prevState => {
            return {
                ...prevState,
                [name]: value,
            }
        })
    }

    const handleOptionClick = () => {
        if(customFormData.optionsField === "" || customFormData.optionsField.toLowerCase() === "null"){
            return;
        }else if (customFormData.duplicateOptions.includes(customFormData.optionsField)) {
            swal({ title: 'Duplicates Found', text: 'duplicate options not allowed' })
            return;
        } else {
            setCustomFormData((prevState) => {
                return {
                    ...prevState,
                    duplicateOptions: [...prevState.duplicateOptions, customFormData.optionsField],
                    selectedOptions: [...prevState.selectedOptions, {
                        displayValue: customFormData.optionsField,
                        value: customFormData.optionsField
                    }],
                    optionsField: ""
                }
            })
        }
    }

    const handleRemoveOptionClick = (e, removeOption) => {
        const filteredOptions = customFormData.selectedOptions.filter(option => (option.value !== removeOption.value))
        const filterDuplicates = customFormData.duplicateOptions.filter(option => option !== removeOption.displayValue)
        setCustomFormData(prevState => ({
            ...prevState,
            selectedOptions: filteredOptions,
            duplicateOptions: filterDuplicates
        }))
    }
    
    useEffect(() => {
        const hasRegex = customFormData.regex
        const isRequired = customFormData.isRequired;
        if (hasRegex && customFormData.validationRule === "custom") {
            setRule(`${isRequired ? "required|" : ""}regex:${customFormData.regex}`)
        } else if (customFormData.validationRule !== "custom") {
            setRule(`${isRequired ? "required|" : ""}${customFormData.validationRule}`)
        }
    }, [customFormData])

    return (
        <div style={formStyles.formContainer}>
            <Row>
                <Col md="3" className="mb-3" >
                    <div className="form-group">
                        <label htmlFor="label">Display Label*</label>
                        <input type="text" className="form-control" id="label" value={customFormData.label} placeholder="Enter Field Label" onChange={handleInputChange} name="label" autoComplete="off" />
                        {validator.message("label", customFormData.label, "required")}
                    </div>
                </Col>
                <Col md="3" className="mb-3" >
                    <div className="form-group">
                        <label htmlFor="fieldName">Field Name (ID)*</label>
                        <input type="text" className="form-control" id="fieldName" value={customFormData.fieldName} placeholder="Enter Field Name" name="fieldName" onChange={handleInputChange} autoComplete="off" />
                        {validator.message("fieldName", customFormData.fieldName, "required")}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md="3" className="mb-3" >
                    <div className="form-group">
                        <label htmlFor="fieldType">Field Type*</label>
                        <select className="form-control" id="fieldType" name="fieldType" value={customFormData.fieldType} onChange={handleInputChange} >
                            {customFieldTypes.map((option => (
                                <option key={option.displayValue} value={option.value} >{option.displayValue}</option>
                            )))}
                        </select>
                        {validator.message("fieldType", customFormData.fieldType, "required")}
                    </div>
                </Col>
                {customFormData.fieldType === "select" &&
                    <>
                        <Col md="3" className="mb-3" >
                            <div style={formStyles.optionContainer}>
                                <div className="form-group">
                                    <label htmlFor="optionsField">Enter Options</label>
                                    <input type="text" className="form-control" id="optionsField" value={customFormData.optionsField} name="optionsField" placeholder="Enter Options" onChange={handleInputChange} autoComplete="off" />
                                    {validator.message("optionsField", customFormData.optionsField, `${customFormData.fieldType === "select" ? customFormData.selectedOptions?.length < 2 ? "required" : "" : ""}`)}
                                </div>

                                <div>
                                    <label style={formStyles.hideLabel}>Add</label>
                                    <button style={formStyles.buttonStyle} className="button-styles" onClick={handleOptionClick} >Add</button>
                                </div>
                            </div>

                        </Col>
                        <Col md="4" className="mb-4" >
                            <label htmlFor="optionsField" style={formStyles.hideLabel} >Option Container</label>
                            {customFormData.selectedOptions?.length > 1 && <div className='option-container' >
                                {customFormData.selectedOptions.map(option => (
                                    <>
                                        {option.displayValue !== "Please Select" && <div className='option'>{option.displayValue}
                                            <i className="fa fa-remove remove-option" onClick={(e) => handleRemoveOptionClick(e, option)} />
                                        </div>}
                                    </>
                                ))
                                }
                            </div>}
                        </Col>
                    </>
                }
            </Row>
            <Row>
                <Col md="3" className="mb-3" >
                    <div className="form-group">
                        <label htmlFor="validationRule">Validation Rules</label>
                        <select className="form-control" id="validationRule" name="validationRule" value={customFormData.validationRule} onChange={handleInputChange} disabled={fieldTypes.includes(customFormData.fieldType)} >
                            {validationRules.map((option) => (
                                <option key={option.displayValue} value={option.value} >{option.displayValue}</option>
                            ))}
                        </select>
                    </div>
                </Col>
                {customFormData.validationRule === "custom" && customFormData.fieldType !== "select" &&
                    <>
                        <Col md="3" className="mb-3" >
                            <div className="form-group">
                                <label htmlFor="label">Regex</label>
                                <input type="text" className="form-control" id="regex" placeholder="Enter Regex" name="regex" value={customFormData.regex} onChange={handleInputChange} autoComplete="off" />
                                {validator.message("regex", customFormData.regex, "required")}
                            </div>
                        </Col>
                        <Col md="3" className="mb-3" >
                            <div className="form-group">
                                <label htmlFor="regexMessage">Regex Validation Message</label>
                                <input type="text" className="form-control" id="regexMessage" value={customFormData.regexMessage} name="regexMessage" placeholder="Enter Regex Validation Message" onChange={handleInputChange} autoComplete="off" />
                                {validator.message("regexMessage", customFormData.regexMessage, "required")}
                            </div>
                        </Col>
                    </>
                }
            </Row>
            <Row>
                <Col md="3" className="mb-3" >
                    <div style={formStyles.checkboxStyle} >
                        <input type="checkbox" className="form-check-input" id="isRequired" value={customFormData.isRequired} checked={customFormData.isRequired} name="isRequired" style={formStyles.checkboxStyle} onChange={handleInputChange} disabled={disableRequiredTypes.includes(customFormData.fieldType)} />
                        <label style={formStyles.checkboxMargin} className="form-check-label" htmlFor="isRequired">Is Required ?</label>
                    </div>
                </Col>
                <Col md="3" className="mb-3" >
                    <div style={formStyles.checkboxStyle}>
                        <input type="checkbox" className="form-check-input" id="showColumn" value={customFormData.showColumn} checked={customFormData.showColumn} name="showColumn" style={formStyles.checkboxStyle} onChange={handleInputChange} />
                        <label style={formStyles.checkboxMargin} htmlFor="showColumn">Show in grid column ?</label>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default React.memo(CustomFields);